<div id="page-user-listing" class="page-section">
    <div class="page-section">
        <div class="page-section-header">
            <h1 translate>Assessment Details</h1>
        </div>
        <div class="page-section-content">
            <div class="table-responsive">
                <page-loader *ngIf="isLoaded"></page-loader>
                <table class="table">
                    <thead *ngIf="assessmentList.length > 0">
                        <tr>
                            <th translate style="width: 25%">UserName</th>
                            <th
                                translate
                                *ngFor="
                                    let header of assessmentList.length > 0 &&
                                        assessmentList[0].FullQuestions;
                                    let i = index
                                ">
                                {{ header.Question }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of assessmentList">
                            <td>
                                {{ data.UserName }}
                            </td>
                            <td
                                *ngFor="
                                    let header of assessmentList[0]
                                        .FullQuestions
                                ">
                                <!-- {{answers | json}} -->
                                <span>{{
                                    getAnswerText(header.QuestionID, data)
                                }}</span>
                                <br />
                                <div
                                    *ngIf="
                                        data.answerMap.get(header.QuestionID)
                                    ">
                                    <div
                                        *ngFor="
                                            let subQuestion of data.answerMap.get(
                                                header.QuestionID
                                            )?.Sub;
                                            let j = index
                                        ">
                                        <span>
                                            {{ subQuestion.Question }}
                                        </span>
                                        <br />
                                        <span>
                                            {{ subQuestion.AnswerValue }}
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="assessmentList.length === 0">
                            <td colspan="5" style="text-align: center">
                                No data to display
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div
                    class="page-section-buttons"
                    *ngIf="assessmentList.length > 0"
                    (click)="LoadMore()">
                    <a tabindex="0" translate>Load More</a>
                </div>
            </div>
        </div>
    </div>
</div>
